<template>
<v-app>
<v-main>

   <m-custom-form-control
    />

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    
}
</script>

<style lang="scss" scoped>
</style>